export default {
      id: "worldLocation-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#worldLocation",
      toString: function () {
        return this.url;
      }
    }